import notify from '../../api/notification'
import examProfileService from '../../api/examProfile'
import {
  EXAM_PROFILE_UPDATE_LIST,
  EXAM_PROFILE_STATUS
} from '../types'

const state = {
  examProfiles: [],
  examProfileStatus: 'STATUS_INITIAL'
}

const mutations = {
  [EXAM_PROFILE_UPDATE_LIST] (state, data) {
    state.examProfiles = data
  },
  [EXAM_PROFILE_STATUS] (state, status) {
    state.examProfileStatus = status
  }
}

const getters = {
  examProfilesList: state => {
    return state.examProfiles
  },
  examProfilesIsLoading: state => {
    return state.examProfileStatus === 'LOADING'
  }
}

const actions = {
  examProfilesGetAll: ({commit}) => {
    commit(EXAM_PROFILE_STATUS, 'LOADING')
    return examProfileService
      .getExamProfiles()
      .then((res) => {
        if (res.status === 200) {
          let items = res.data
          items = items.map((item) => {
            let exams = item.profile_exams
            exams = exams.map((exam) => {
              return {
                id: exam.id_exam,
                name: exam.name_exam,
                examCode: exam.code_exam,
                material: exam.material_description
              }
            })
            return {
              id: item.id_profile,
              name: item.name,
              author: item.responsible_by,
              showDetail: false,
              exams,
              laboratories: item.laboratories,
              id_laboratory_owner: item.id_laboratory_owner,
              id_matriz: item.id_matriz,
              operator: item.operator
            }
          })
          commit(EXAM_PROFILE_UPDATE_LIST, items)
          commit(EXAM_PROFILE_STATUS, 'STATUS_INITIAL')
        }
      })
      .catch(() => {
        commit(EXAM_PROFILE_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao carregar perfis de exames.'
        })
      })
  },
  examProfileDelete: ({commit, dispatch}, item) => {
    commit(EXAM_PROFILE_STATUS, 'LOADING')
    return examProfileService
      .deleteExamProfile(item.id)
      .then(() => {
        dispatch('examProfilesGetAll')
        notify({
          message: 'Perfil de exames excluído com sucesso!'
        })
      })
      .catch(() => {
        commit(EXAM_PROFILE_STATUS, 'STATUS_INITIAL')
        notify({
          title: 'AVISO: ',
          message: 'Erro ao deletar perfi de exames.'
        })
      })
  }
}

export default { state, mutations, actions, getters }
export { mutations, actions, getters }
